import './worldmap.css';
import './worldmap-layout.css';
import './worldmap-media-queries.css';
import { fetch, currentPath, setRoute } from './utils';
import panzoom from './panzoom';

let container, svg, highlightedCountry, controller;

const svgPromise = fetch('/assets/world.svg')
.then(xml => {
  if (xml.length) {
    svg = xml[0];
    // paths = svg.querySelectorAll('path');
    return init(svg);
  }

  throw new Error('Cannot load map');
});


export function onMapReady () {
  return svgPromise;
}

export function setPathAttributes (attrName, newValues) {
  onMapReady()
    .then(() => {
      const elemsToReset = svg.querySelectorAll(`[${attrName}]`);

      for (let i = 0; i < elemsToReset.length; i ++) {
        elemsToReset[i].removeAttribute(attrName);
      }

      Object.keys(newValues).forEach(countryId => {
        const countryElem = getCountryElem(countryId);

        if (countryElem) {
          countryElem.setAttribute(attrName, newValues[countryId]);
        }

        else {
          console.log('MISSING COUNTRY', countryId);
        }
      });
    });
}

export function currentScale (squareRoot = false) {
  if (!controller) {
    return 1;
  }

  const scale = controller.currentScale;

  return scale && squareRoot ? controller.scaleSquareRoot(scale) : scale;
}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
export function fadeOut () {
  container.classList.remove('active');
}

export function fadeIn () {
  container.classList.add('active');
}

export function zoom (scale = 1) {
  controller.setOriginViaViewportRatio(0.5, 0.5, true);
  controller.scale(controller.scaleSquare(scale));
}

export function zoomIn (scaleDiff = 1) {
  controller.setOriginViaViewportRatio(0.5, 0.5, true);
  controller.zoomIn(scaleDiff);
}

export function zoomOut (scaleDiff = 1) {
  controller.setOriginViaViewportRatio(0.5, 0.5, true);
  controller.zoomOut(scaleDiff);
}

export function panLeft () {
  controller.translate(controller.dx - 10, controller.dy);
}

export function panRight () {
  controller.translate(controller.dx + 10, controller.dy);
}

export function panUp () {
  controller.translate(controller.dx, controller.dy - 10);
}

export function panDown () {
  controller.translate(controller.dx, controller.dy + 10);
}

export function onScaleChange (fn) {
  onMapReady().then(controller => controller.onScaleChange(fn));
}

export function onResize (fn) {
  onMapReady().then(controller => controller.onResize(fn));
}

export function resetMap () {
  // console.log('resetMap');

  if (controller) {
    controller.resetView();
  }
}

export function repaint () {
  // console.log('repaint');
  controller.updateTransform(true);
}



let currentCountryId = null;

export function getCountryElem (countryId) {
  return countryId && svg.querySelector('[data-country=' + countryId.toUpperCase() + ']') || null;
}

export function getCountryBBox (countryElem) {
  if (!countryElem) {
    return null;
  }

  return countryElem.getBBox();
}

export function positionCountry () {
  // console.log('positionCountry', window.innerWidth, window.innerHeight);
  controller.captureDimensions();

  if (window.innerWidth <= 300) {
    // console.log('0.7', [window.innerWidth, window.innerHeight]);
    controller.setViewportOriginRatio(0.8, 0.5);
  }

  // if (window.innerWidth <= 450 || window.innerHeight <= 600) {
  else if (window.innerWidth <= 450) {
    // console.log('0.7', [window.innerWidth, window.innerHeight]);
    controller.setViewportOriginRatio(0.7, 0.5);
  }
  
  else {
    // console.log('0.62', [window.innerWidth, window.innerHeight]);
    controller.setViewportOriginRatio(0.62, 0.5);
  }
}

export function selectCountry (id) {
  // TEMP
  if (!svg) {
    setTimeout(() => selectCountry(id), 500);
    return;
  }

  if (!id) {
    return;
  }

  const updateCountry = id !== currentCountryId;
  const countryElem = getCountryElem(id);
  
  if (updateCountry) {
    if (currentCountryId) {
      deselectCountry();
    }

    currentCountryId = id;
    container.classList.add('country-selected');
    countryElem.classList.add('selected');
  }

  const countryBBox = getCountryBBox(countryElem);

  positionCountry();

  // console.log('selectCountry', { countryBBox });
  controller.contain(countryBBox, { scaleRatio: 0.38, animate: false });
}

// window.addEventListener('orientationchange', () => setTimeout(repaint);

export function deselectCountry () {
  // if (!currentCountryId) {
  //   return;
  // }

  currentCountryId = null;

  if (container) {
    container.classList.remove('country-selected');

    if (svg) {
      const countryElem = svg.querySelector('.selected');

      if (countryElem) {
        countryElem.classList.remove('selected');
      }
    }
  }
}

function onMouseOver (event) {
  // console.log('mouseover', controller.panStartTime, controller.panStopTime, Date.now() - controller.panStopTime);

  if (event.target.nodeName !== 'path' || !event.target.getAttribute('data-value')) {
    return;
  }

  if (controller && controller.panStartTime && controller.panStopTime && (controller.panStopTime - controller.panStartTime) < 200 && (Date.now() - controller.panStopTime) < 100) {
    return;
  }

  const countryId = event.target.getAttribute('data-country');

  if (countryId) {
    highlightedCountry.appendChild(event.target.cloneNode());
    highlightedCountry.appendChild(event.target.cloneNode());
  }
}

function onMouseOut () {
  // if (event.target.nodeName === 'path') {
    // svg.setAttribute('data-country', '');
    
    // const countryBackground = svg.querySelector('#selected-background');

    // if (countryBackground) {
    //   svg.removeChild(countryBackground);
    // }

    while (highlightedCountry.firstChild) {
      highlightedCountry.removeChild(highlightedCountry.firstChild);
    }
  // }
}

function onClick (event) {
  // setTimeout(() => {
    // panning finished; prevents a pan that ends on a country selecting the
    // country

    const now = Date.now();

    // console.log('click', controller.panning, now - controller.panStartTime, now - controller.panStopTime);
      
    // if (controller.panning || (controller.panStartTime && (now - controller.panStartTime) < 200) || controller.panStopTime && (now - controller.panStopTime) < 100) {
    //   return;
    // }

    // console.log('click', controller.panStopTime, (Date.now() - controller.panStopTime));


    if (event.target.nodeName === 'path') {
      const countryId = event.target.getAttribute('data-country');

      if (countryId) {
        const { year } = currentPath();

        setRoute(year, countryId.toLowerCase());
        selectCountry(countryId);
      }

      // else {
        // controller.setViewportOrigin(event.clientX - svg.clientLeft, event.clientY - svg.clientTop);
        // controller.zoomIn();
      // }
    }
  // }, 4);
}

function onDblClick (event) {
  // TODO: animate zoomIn

  // console.log('dblclick');

  controller.setOriginViaViewport(event.clientX - controller.zoomDelegate.offsetLeft, event.clientY - controller.zoomDelegate.offsetTop, true);
  // controller.setOriginViaViewport(event.screenX - window.scrollX, event.screenY - window.scrollY, true);
  controller.zoomIn(1);
}

function addListeners () {
  svg.addEventListener('mouseover', onMouseOver);
  svg.addEventListener('mouseout', onMouseOut);
  // svg.addEventListener('click', onClick);

  // svg.addEventListener('touchstart', onClick);
  svg.addEventListener('dblclick', onDblClick);
}

function removeListeners () {
  svg.removeEventListener('mouseover', onMouseOver);
  svg.removeEventListener('mouseout', onMouseOut);
  // svg.removeEventListener('click', onClick);
  // svg.removeEventListener('touchstart', onClick);
  svg.removeEventListener('dblclick', onDblClick);
}


// Fix address bar height and vh units on mobile
// let vh = window.innerHeight * 0.01;
// document.documentElement.style.setProperty('--vh', `${vh}px`);

// function setVh () {
//   const newVh = window.innerHeight * 0.01;

//   if (newVh !== vh) {
//     vh = newVh;
//     document.documentElement.style.setProperty('--vh', `${vh}px`);
//   }
// }

function init (svg) {
  container = document.getElementById('worldmap');

  if (container) {
    return;
  }

  container = document.createElement('div');
  container.id = 'worldmap';

  if (currentPath().countryId) {
    container.classList.add('country-selected');
  }

  document.body.insertBefore(container, document.body.firstChild);

  highlightedCountry = document.createElementNS('http://www.w3.org/2000/svg', 'g');
  highlightedCountry.classList.add('highlighted-country');
  svg.firstElementChild.appendChild(highlightedCountry);

  addListeners();

  container.appendChild(svg);

  // if (window.innerHeight < document.body.offsetHeight) {
    // console.log('resize map height', window.innerHeight, document.body.offsetHeight);

    // container.style.height = 100px; //`${container.offsetHeight - (document.body.offsetHeight - window.innerHeight)}px`;
  // }

  controller = panzoom(svg, {
    autosize: true,
    paddingLeft: '16.2%',
    paddingRight: '16.2%',
    paddingTop: '16.2%',
    paddingBottom: '16.2%',
    zoomMin: 0.2,     
    zoomMax: 10,      
    zoomIncrement: 0.5,
    zoomSpeed: 250,
    panTransitionIncrement: 0.5,
    panGutterRight: 20,
    zoomTransitionIncrement: 0.1
  });

  controller.onClick(onClick);

  // const worldbitmap = document.createElementNS('http://www.w3.org/2000/svg', 'image');
  // const { paddingLeft, paddingRight, paddingTop, paddingBottom } = controller.getPadding();

  // const bbox = svg.firstElementChild.getBBox();
  // console.log({bbox});

  // worldbitmap.setAttribute('class', 'worldbitmap');
  // worldbitmap.setAttribute('opacity', 0.3);
  // worldbitmap.setAttribute('x', bbox.x);
  // worldbitmap.setAttribute('y', bbox.y);
  // worldbitmap.setAttribute('width', bbox.width);
  // worldbitmap.setAttribute('height', bbox.height);
  // worldbitmap.setAttribute('href', '/assets/world.png');
  // svg.firstElementChild.appendChild(worldbitmap);

  let waitingForAnimation = false;

  window.addEventListener('resize', function () {
    if (waitingForAnimation) {
      return;
    }

    waitingForAnimation = true;

    requestAnimationFrame(() => {
      waitingForAnimation = false;
      
      // setVh();

      if (currentCountryId) {
        selectCountry(currentCountryId);
      }

      else {
        resetMap();
      }

      controller.updateTransform(true);

      // const width = window.innerWidth;
      // const height = window.innerHeight;

      // setTimeout(() => {
      //   if (width !== innerWidth || height !== innerHeight) {
      //     console.log('setting 2');
      //     setVh();

      //     if (currentCountryId) {
      //       positionCountry();
      //     }

      //     controller.updateTransform(true);
      //   }
      // }, 250);
    });
  });

  window.c = controller;

  return controller;
}



// WEBPACK FOOTER //
// ./lib/worldmap.js